export default __webpack_public_path__ + "static/media/dijital-kullanicilar.c01fa212.jpg";